import { useQuery } from '@tanstack/react-query'
import type { Account, ConfirmNotificationEmailOutput } from '@terafile/shared'
import { apiFetch } from './api.js'

/**
 * ログイン中の利用者自身の情報（ログイン用・通知先のメールアドレス）。Issue #118。
 *
 * 運営も含め Supabase のログインがあるときだけ叩く。お試し中（暫定テナント）は
 * 利用者のレコードが無いので呼ばない。
 */

export const ACCOUNT_QUERY_KEY = ['account'] as const

async function getAccount(): Promise<Account> {
  return apiFetch<Account>('/account')
}

/**
 * 通知先の変更を申し込む（新しいアドレスへ確認メールが届く）。
 * ログイン用と同じアドレスなら確認なしで「ログイン用に届ける」に戻る。
 */
export async function requestNotificationEmailChange(email: string): Promise<Account> {
  return apiFetch<Account>('/account/notification-email', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
}

/** 確認メールのリンク先から呼ぶ。ログインしていなくても使える */
export async function confirmNotificationEmail(
  token: string,
): Promise<ConfirmNotificationEmailOutput> {
  return apiFetch<ConfirmNotificationEmailOutput>('/notification-email/confirm', {
    method: 'POST',
    body: JSON.stringify({ token }),
  })
}

export function useAccount(options: { enabled: boolean }) {
  return useQuery({
    queryKey: ACCOUNT_QUERY_KEY,
    queryFn: getAccount,
    enabled: options.enabled,
    // サイドバーで常に表示する。変更は本人の操作でしか起きず、そのとき明示的に更新するので長めに持つ
    staleTime: 5 * 60 * 1000,
  })
}
